
























































































import { Component, Prop, PropSync, Ref, Vue, Watch } from 'vue-property-decorator'
import { FindMetasUseCase } from '@/usecases/meta'
import ListaDeMetas from '@/components/metas/ListaDeMetas.vue'
import TelaGenerica from '@/components/layout/TelaGenerica.vue'
import { MetaModule } from '@/store/vuex/meta/MetaStore'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import axios, { CancelTokenSource } from 'axios'
import MenuDeFiltroDeMetas from '@/components/metas/MenuDeFiltroDeMetas.vue'
import { FiltroDeBuscaDeMetas, Meta } from '@/models/Meta'
import { Page } from '@/models/Page'
import { Pageable, Usuario } from '@/models'
import SeletorDeLojasDoUsuario from '@/components/loja/SeletorDeLojasDoUsuario.vue'

const FILTRO_DE_METAS = 'FILTRO_DE_METAS'

@Component({
	components: {
		TelaGenerica,
		ListaDeMetas,
		MenuDeFiltroDeMetas,
		SeletorDeLojasDoUsuario,
	},
})
export default class TelaDeMetas extends Vue {
	@PropSync('value') selecionado!: Meta | null
	@Prop({ type: Function }) to?: (meta: Meta) => void
	@Ref() listaDeMetas!: ListaDeMetas
	@Ref() filtroMeta!: MenuDeFiltroDeMetas

	findMetasUseCase = new FindMetasUseCase()

	cancelToken: CancelTokenSource | null = null
	pagina: Page<Meta> | null = null
	filtroAplicado: FiltroDeBuscaDeMetas = localStorage[FILTRO_DE_METAS]
		? JSON.parse(localStorage[FILTRO_DE_METAS])
		: { idVendedorAtribuido: null, descricao: null, valor: null, lojaId: '' }
	idLoja: string | null = null
	page = 1
	totalPages = 1
	carregando = false

	filtrar(filtros: FiltroDeBuscaDeMetas) {
		this.filtroAplicado = { ...filtros }
		this.page = 1
		this.buscarMetas()
	}

	onLimparBusca() {
		this.filtroAplicado = { ...this.filtroAplicado, descricao: null }
		this.page = 1
		this.buscarMetas()
	}

	async buscarMetas(paginavel: Pageable = { page: this.page - 1, size: 40 }) {
		if (!this.filtroAplicado.lojaId) return
		if (this.cancelToken) this.cancelToken.cancel()
		this.cancelToken = axios.CancelToken.source()
		try {
			this.carregando = true
			this.pagina = await this.findMetasUseCase.findMetas(
				{ ...this.filtroAplicado, ...paginavel },
				{ cancelToken: this.cancelToken.token },
			)
			MetaModule.setMetas(this.pagina.content)
			this.totalPages = this.pagina.totalPages || 1
		} catch (error: any) {
			if (axios.isCancel(error)) return
			this.pagina = null
			AlertModule.setError(error)
		} finally {
			this.carregando = false
		}
	}

	abrirEdicao() {
		this.$router.push({ name: 'Nova Meta' })
	}

	get metasFiltradas() {
		return MetaModule.metasFiltradas
	}

	get filtro() {
		return MetaModule.filtrar
	}

	@Watch('filtro')
	onChangeFiltro() {
		localStorage.setItem(FILTRO_DE_METAS, JSON.stringify(this.filtroAplicado))
		this.buscarMetas()
		MetaModule.atualizarFiltro(false)
	}

	@Watch('page')
	onChangePage() {
		this.buscarMetas()
	}

	@Watch('idLoja')
	onChangeIdLoja(lojaId: string | null) {
		this.filtroAplicado = { ...this.filtroAplicado, lojaId: lojaId || null }
		this.page = 1
		this.buscarMetas()
	}

	created() {
		this.filtroAplicado.lojaId = null
	}
}
